<div class="legal-notice-content content-limitation" [innerHTML]="content"></div>